// Implements: F-IDN-017
/**
 * Why the erasure of the own account was refused. The server answers `409` with
 * `details {field: "mockups", reason: "still_responsible"}` while the person still owns team or
 * organization mockups (trash included; the personal ones leave with the account): retrying can never
 * work, so the dialog says why and how to hand them over.
 * Anything else is a failure worth retrying.
 */

import type { ErrorDetails } from "../../../types/errors";

export type EraseRefusal = "stillResponsible" | "failed";

/** What the dialog needs of a failed erasure: the status and the envelope's `details`. */
export interface EraseFailure {
  readonly status: number;
  readonly details: ErrorDetails | null;
}

/** The only resource the server names today; another one would need its own steps. */
const OWNED_RESOURCE = "mockups";
const STILL_RESPONSIBLE = "still_responsible";

/** `null` while nothing failed; otherwise which notice the dialog shows. */
export function eraseRefusalOf(error: EraseFailure | null): EraseRefusal | null {
  if (error === null) return null;
  const { status, details } = error;
  const stillOwns = status === 409 && details?.field === OWNED_RESOURCE && details.reason === STILL_RESPONSIBLE;
  return stillOwns ? "stillResponsible" : "failed";
}
